import { IBaseAction } from '../../../../common/interfaces/IBaseAction'
export enum Keys {
    GETSCHEDULES= 'react/reservationSchedules/GETSCHEDULES',
    GETSCHEDULES_FULFILLED= 'react/reservationSchedules/GETSCHEDULES_FULFILLED',
    GETSCHEDULES_REJECTED= 'react/reservationSchedules/GETSCHEDULES_REJECTED',
    GETSCHEDULES_PENDING= 'react/reservationSchedules/GETSCHEDULES_PENDING',

    SAVESCHEDULE = 'react/reservationSchedules/SAVESCHEDULE',
    SAVESCHEDULE_PENDING = 'react/reservationSchedules/SAVESCHEDULE_PENDING',
    SAVESCHEDULE_FULFILLED = 'react/reservationSchedules/SAVESCHEDULE_FULFILLED',
    SAVESCHEDULE_REJECTED = 'react/reservationSchedules/SAVESCHEDULE_REJECTED',

    DELETESCHEDULE = "react/reservationSchedules/DELETESCHEDULE",
    DELETESCHEDULE_PENDING = 'react/reservationSchedules/DELETESCHEDULE_PENDING',
    DELETESCHEDULE_FULFILLED = 'react/reservationSchedules/DELETESCHEDULE_FULFILLED',
    DELETESCHEDULE_REJECTED = 'react/reservationSchedules/DELETESCHEDULE_REJECTED',

    CREATESCHEDULE = "react/reservationSchedules/CREATESCHEDULE",
    CREATESCHEDULE_PENDING = 'react/reservationSchedules/CREATESCHEDULE_PENDING',
    CREATESCHEDULE_FULFILLED = 'react/reservationSchedules/CREATESCHEDULE_FULFILLED',
    CREATESCHEDULE_REJECTED = 'react/reservationSchedules/CREATESCHEDULE_REJECTED',

    LOADACTIVITIES = 'react/activities/LOADACTIVITIES',
    LOADACTIVITIES_PENDING = 'react/activities/LOADACTIVITIES_PENDING',
    LOADACTIVITIES_FULFILLED = 'react/activities/LOADACTIVITIES_FULFILLED',
    LOADACTIVITIES_REJECTED = 'react/activities/LOADACTIVITIES_REJECTED',

    GETRESERVATIONS= 'react/reservationSchedules/GETRESERVATIONS',
    GETRESERVATIONS_FULFILLED= 'react/reservationSchedules/GETRESERVATIONS_FULFILLED',
    GETRESERVATIONS_REJECTED= 'react/reservationSchedules/GETRESERVATIONS_REJECTED',
    GETRESERVATIONS_PENDING= 'react/reservationSchedules/GETRESERVATIONS_PENDING',

    ADDRESERVATION= 'react/reservationSchedules/ADDRESERVATION',
    ADDRESERVATION_FULFILLED= 'react/reservationSchedules/ADDRESERVATION_FULFILLED',
    ADDRESERVATION_REJECTED= 'react/reservationSchedules/ADDRESERVATION_REJECTED',
    ADDRESERVATION_PENDING= 'react/reservationSchedules/ADDRESERVATION_PENDING',

    REMOVERESERVATION= 'react/reservationSchedules/REMOVERESERVATION',
    REMOVERESERVATION_FULFILLED= 'react/reservationSchedules/REMOVERESERVATION_FULFILLED',
    REMOVERESERVATION_REJECTED= 'react/reservationSchedules/REMOVERESERVATION_REJECTED',
    REMOVERESERVATION_PENDING= 'react/reservationSchedules/REMOVERESERVATION_PENDING',
    OTHER_ACTION = 'react/reservationSchedules/__any_other_action__',
}

export type Types = IBaseAction<Keys>;